import { ChangeDetectorRef, Component, ElementRef, Injector, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { TabsComponent } from '../tabs.component';
declare var bootstrap: any;

@Component({
  selector: 'tab',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.scss']
})
export class TabComponent implements OnInit {
  @ViewChild('tabContent') tabContentRef?: ElementRef<HTMLDivElement>;
  @Input() template?: TemplateRef<unknown>;
  @Input() key: any;
  @Input() label: string = "";
  @Input() icon?: string;

  public tabs?: TabsComponent;
  public cdRef: ChangeDetectorRef;

  constructor(public injector: Injector) {
    this.cdRef = injector.get<ChangeDetectorRef>(ChangeDetectorRef);
   }

  public get isActive(): boolean {
    return this.tabs?.active == this.key;
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(){
    if (this.isActive && this.tabContentRef?.nativeElement) {
      this.activateTooltipsForActiveTab();
    }
  }

  public activateTooltipsForActiveTab(): void {
    const tooltipElements = this.tabContentRef?.nativeElement.querySelectorAll('[data-bs-toggle="tooltip"]');
    tooltipElements?.forEach((tooltipElement) => {
      new bootstrap.Tooltip(tooltipElement);
    });
  }
}
